import { useState, useEffect,useContext } from "react";
import { McDrawer } from "@maersk-global/mds-react-wrapper/components-core/mc-drawer";
import { McButton } from "@maersk-global/mds-react-wrapper/components-core/mc-button";
import { McIcon } from "@maersk-global/mds-react-wrapper/components-core/mc-icon";
import { McLoadingIndicator } from "@maersk-global/mds-react-wrapper/components-core/mc-loading-indicator";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { TableContext } from "../context";
import axios from 'axios';

function CiInfoDrawer({ isdrawerOpen, setisdrawerOpen, drawerCi, drawerCiCategory }) {
    const [drawerData, setDrawerData] = useState(null);
    const [drawerContent, setDrawerContent] = useState("");
    const [drawerHeading, setDrawerHeading] = useState("");
    const {getToken} = useContext(TableContext);
    const fetchData = async () => {
        setDrawerData(null);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URI}/api/change_data/getApplicationDetails`,
                {
                    app_details: drawerCi,
                    category: drawerCiCategory,
                },
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("jwt_token"),
                    }
                }
            );
            
            if (response.data?.status === 200) {
                console.log("CI Info: ", response.data);
                const apiData = response.data;
                setDrawerData(apiData);
                setDrawerHeading('CI Information');
                setDrawerContent(
                    <div style={{ display: "flex", gap: "20px", flexDirection: "column", padding: "4px" }}>
                        <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
                            <span style={{ color: "#545454", fontSize: "1rem", fontWeight: "600" }}>
                                Application ID
                            </span>
                            <input
                                type="text"
                                value={apiData?.applicationId || "NA"}
                                disabled
                                style={{
                                    fontSize: "1rem",
                                    borderRadius: "8px",
                                    border: "1px solid #e0e0e0",
                                    background: "#f7f7f7",
                                    padding: "8px 12px",
                                    color: "#222",
                                    outline: "none",
                                    width: "100%",
                                    boxSizing: "border-box",
                                }}
                            />
                        </div>
                        <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
                            <span style={{ color: "#545454", fontSize: "1rem", fontWeight: "600" }}>
                                Application Name
                            </span>
                            <input
                                type="text"
                                value={apiData?.applicationName || "NA"}
                                disabled
                                style={{
                                    fontSize: "1rem",
                                    borderRadius: "8px",
                                    border: "1px solid #e0e0e0",
                                    background: "#f7f7f7",
                                    padding: "8px 12px",
                                    color: "#222",
                                    outline: "none",
                                    width: "100%",
                                    boxSizing: "border-box",
                                }}
                            />
                        </div>
                        <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
                            <span style={{ color: "#545454", fontSize: "1rem", fontWeight: "600" }}>
                                Owner
                            </span>
                            <input
                                type="text"
                                value={apiData?.owner || "NA"}
                                disabled
                                style={{
                                    fontSize: "1rem",
                                    borderRadius: "8px",
                                    border: "1px solid #e0e0e0",
                                    background: "#f7f7f7",
                                    padding: "8px 12px",
                                    color: "#222",
                                    outline: "none",
                                    width: "100%",
                                    boxSizing: "border-box",
                                }}
                            />
                        </div>
                        <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
                            <span style={{ color: "#545454", fontSize: "1rem", fontWeight: "600" }}>
                                Platform
                            </span>
                            <input
                                type="text"
                                value={apiData?.platform || "NA"}
                                disabled
                                style={{
                                    fontSize: "1rem",
                                    borderRadius: "8px",
                                    border: "1px solid #e0e0e0",
                                    background: "#f7f7f7",
                                    padding: "8px 12px",
                                    color: "#222",
                                    outline: "none",
                                    width: "100%",
                                    boxSizing: "border-box",
                                }}
                            />
                        </div>
                        <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
                            <span style={{ color: "#545454", fontSize: "1rem", fontWeight: "600" }}>
                                Portfolio
                            </span>
                            <input
                                type="text"
                                value={apiData?.portfolio || "NA"}
                                disabled
                                style={{
                                    fontSize: "1rem",
                                    borderRadius: "8px",
                                    border: "1px solid #e0e0e0",
                                    background: "#f7f7f7",
                                    padding: "8px 12px",
                                    color: "#222",
                                    outline: "none",
                                    width: "100%",
                                    boxSizing: "border-box",
                                }}
                            />
                        </div>
                        <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
                            <span style={{ color: "#545454", fontSize: "1rem", fontWeight: "600" }}>
                                MVC
                            </span>
                            <input
                                type="text"
                                value={apiData?.mvc || "NA"}
                                disabled
                                style={{
                                    fontSize: "1rem",
                                    borderRadius: "8px",
                                    border: "1px solid #e0e0e0",
                                    background: "#f7f7f7",
                                    padding: "8px 12px",
                                    color: "#222",
                                    outline: "none",
                                    width: "100%",
                                    boxSizing: "border-box",
                                }}
                            />
                        </div>
                        {apiData?.applicationName && apiData.applicationName !== "NA" && (
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <span style={{ color: "#545454", fontSize: "1rem", fontWeight: "600" }}>
                                    Additional Information:
                                </span>
                                <a
                                    href={`${process.env.REACT_APP_MSA_LINK}/asset_lookup?applicationName=${apiData.applicationName.replace(/\s+/g, '+')}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        color: "#0077b2",
                                        textDecoration: "underline",
                                        fontSize: "1rem",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "4px",
                                        width: "fit-content"
                                    }}
                                >
                                    MSA <McIcon icon="square-arrow-up-right"></McIcon>
                                </a>
                            </div>
                        )}
                    </div>
                );
            } else if (response.data?.message?.includes("No details found")) {
                console.log("No information found for this CI");
                setDrawerData(["No information found for this CI"]);
                setDrawerContent(
                    <span>
                        No details found for this CI
                    </span>
                );
            } else {
                console.error('Failed to fetch CI info');
                // toast.error("Failed to fetch CI info", {
                //     position: "top-center",
                //     autoClose: 3000,
                //     hideProgressBar: false,
                //     closeOnClick: true,
                //     pauseOnHover: true,
                //     draggable: true,
                //     progress: undefined,
                //     theme: "light",
                // });
                setDrawerContent(
                    <span>
                        No details found for this CI
                    </span>
                );
                setDrawerData(["No information found for this CI"]);
            }
        } catch (error) {
            console.error("Error fetching CI info", error);
            setDrawerData(["No information found for this CI"]);
            toast.error("Error fetching CI info", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            setDrawerContent(
                <span>
                    No details found for this CI
                </span>
            );
        }
    };

    const handleDrawerClose = () => {
        setisdrawerOpen(false);
        setDrawerContent("");
        setDrawerHeading("");
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <McDrawer
                open={isdrawerOpen}
                closed={handleDrawerClose}
            >
                <span slot="heading">
                    CI Information
                </span>

                {drawerData == null ? (
                    <div
                        style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        }}
                    >
                        <McLoadingIndicator appearance="primary"></McLoadingIndicator>
                    </div>
                ) : (
                    <>
                        <div style={{ marginTop: "10px" }}>{drawerContent}</div>
                        <McButton
                            slot="footer"
                            dialogaction="close"
                            onClick={handleDrawerClose}
                        >
                            Close
                        </McButton>
                    </>
                )}
            </McDrawer>

        </div>
    );
}

export default CiInfoDrawer;